// extracted by mini-css-extract-plugin
export default {"confirmMainBox":"LeadConfirmWhiteLabel_confirmMainBox__TeQtF","box":"LeadConfirmWhiteLabel_box__SaJys","privacyNotice":"LeadConfirmWhiteLabel_privacyNotice__CBuK0"};